import React from 'react';
import LoginPage from './LoginPage';

const SignupPage = () => {
  return <LoginPage defaultPanel="signup" />;
};

export default SignupPage;